import { Pipe, PipeTransform } from '@angular/core';

import {
  CSGO_Extras,
  CSGO_Rarity,
  CSGO_COLORS,
  CSGO_STATTRAK_COLOR,
  Dota2_Extras,
  Rust_Extras,
  SteamApp,
  DOTA2_COLORS,
  RUST_COLORS
} from '../items.entity';

const DEFAULT_COLOR = CSGO_COLORS[CSGO_Rarity.BASE_GRADE];

@Pipe({
  name: 'itemColor'
})
export class ItemColorPipe implements PipeTransform {
  transform(itemExtras: CSGO_Extras|Dota2_Extras|Rust_Extras|null, appId: SteamApp): string {
    if(!itemExtras) {
      return DEFAULT_COLOR;
    }

    if(appId === SteamApp.CSGO) {
      return this.getCsgoColor(itemExtras as CSGO_Extras);
    } else if(appId === SteamApp.DOTA2) {
      return this.getDota2Color(itemExtras as Dota2_Extras);
    } else if(appId === SteamApp.RUST) {
      return this.getRustColor(itemExtras as Rust_Extras);
    }

    return DEFAULT_COLOR;
  }

  private getCsgoColor(extras: CSGO_Extras): string {
    if(extras.st) {
      return CSGO_STATTRAK_COLOR;
    }

    return CSGO_COLORS[extras.r];
  }

  private getDota2Color(extras: Dota2_Extras): string {
    if(!extras.r) {
      return DEFAULT_COLOR;
    }

    return DOTA2_COLORS[extras.r];
  }

  private getRustColor(extras: Rust_Extras): string {
    if(!extras.c) {
      return DEFAULT_COLOR;
    }

    return RUST_COLORS[extras.c];
  }
}